// extracted by css-extract-rspack-plugin
export default {"event":"event__event___Jflwv common__eventBox___nMkZv common__box___P1CnO","text":"event__text___TCk3D","link":"event__link___SnOYG common__linkText___X4rj0"};